const types = {
  NEXT: '@@fsm/EVENT/NEXT',
  BACK: '@@fsm/EVENT/BACK',
  START: '@@fsm/EVENT/START',
  MODIFY: '@@fsm/EVENT/MODIFY',
  END: '@@fsm/EVENT/END',
  CALL_ME_BACK: '@@fsm/EVENT/CALL_ME_BACK',
};

export const start = () => ({ type: types.START });
export const next = payload => ({ type: types.NEXT, payload });
export const back = () => ({ type: types.BACK });
export const modify = payload => ({ type: types.MODIFY, payload });
export const end = payload => ({ type: types.END, payload });
export const callMeBack = payload => ({ type: types.CALL_ME_BACK, payload });

export default types;
